/* diXed, Punkte statt Zahlen an jedem Schieber. Angelegt am 29.08.2026.

   Dawn zeigt "1 / 4". Dieses Skript laesst die Zahlen stehen, blendet sie
   aber aus und setzt an ihre Stelle Punkte. Es ruehrt keine Dawn-Datei an
   und gilt fuer jeden Schieber, auch fuer spaeter hinzukommende. */
(function () {
  function zahl(el) {
    var n = parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10);
    return isNaN(n) ? 0 : n;
  }

  function bauen(leiste) {
    var zaehler = leiste.querySelector('.slider-counter');
    if (!zaehler || leiste.querySelector('.dixed-punkte')) return;
    var jetzt = zaehler.querySelector('.slider-counter--current');
    var summe = zaehler.querySelector('.slider-counter--total');
    if (!jetzt || !summe) return;

    var halter = document.createElement('div');
    halter.className = 'dixed-punkte';
    zaehler.parentNode.insertBefore(halter, zaehler.nextSibling);

    var vor = leiste.querySelector('.slider-button--prev');
    var zurueck = leiste.querySelector('.slider-button--next');

    function springe(ziel) {
      var da = zahl(jetzt);
      var schritte = Math.abs(ziel - da);
      var knopf = ziel > da ? zurueck : vor;
      if (!knopf) return;
      for (var i = 0; i < schritte; i++) knopf.click();
    }

    function zeichne() {
      var gesamt = zahl(summe);
      var aktiv = zahl(jetzt);
      if (gesamt < 2) { halter.textContent = ''; return; }
      if (halter.children.length !== gesamt) {
        halter.textContent = '';
        for (var i = 1; i <= gesamt; i++) {
          var p = document.createElement('button');
          p.type = 'button';
          p.className = 'dixed-punkt';
          p.setAttribute('aria-label', 'Zu Ansicht ' + i);
          (function (nr) {
            p.addEventListener('click', function () { springe(nr); });
          })(i);
          halter.appendChild(p);
        }
      }
      for (var j = 0; j < halter.children.length; j++) {
        halter.children[j].classList.toggle('dixed-punkt--aktiv', j + 1 === aktiv);
      }
    }

    zeichne();
    new MutationObserver(zeichne).observe(zaehler, {
      childList: true, subtree: true, characterData: true
    });
    leiste.classList.add('dixed-hat-punkte');
  }

  function start() {
    var leisten = document.querySelectorAll('.slider-buttons');
    for (var i = 0; i < leisten.length; i++) bauen(leisten[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  /* Dawn baut Schieber teils erst nach dem Laden fertig. */
  window.addEventListener('load', start);

  /* Nachgeladene Schieber, ergaenzt am 06.09.2026.
     Die Produktempfehlungen auf der Produktseite kommen per fetch und damit
     nach window.load: product-recommendations ersetzt seinen Inhalt selbst.
     start() war dann laengst durch, dort standen Zahlen statt Punkte.
     bauen() bricht ab, wenn eine Leiste schon Punkte hat, deshalb ist der
     wiederholte Lauf folgenlos. Die kurze Sperre buendelt die vielen
     Meldungen, die ein Austausch des Inhalts ausloest. */
  var wartet = false;
  new MutationObserver(function () {
    if (wartet) return;
    wartet = true;
    setTimeout(function () { wartet = false; start(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
